import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="10177" id="hero-intro" ref={ref} className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className={`absolute inset-0 z-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-105 blur-sm"}`}>
        <div className="absolute inset-0 flex items-center justify-center text-primary opacity-5 text-[200px] font-serif select-none">
          A
        </div>
        {}
        <div className="absolute inset-0 bg-background/50 mix-blend-multiply" />
      </div>

      {}
      <div className={`relative z-10 container mx-auto px-6 text-center transition-all duration-700 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}>
        <div className="max-w-3xl mx-auto flex flex-col items-center gap-8">
          {}
          <h1 className="font-serif font-bold text-6xl md:text-7xl lg:text-8xl tracking-tight text-primary drop-shadow-none">
            Names Starting with A
          </h1>

          {}
          <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
            Explore the deep-rooted origins and enduring popularity of names beginning with 'A'. From timeless classics to modern favorites, these names lead the way with character, ambition, and strength.
          </p>

          {}
          <div className="pt-4">
            <Button asChild className="rounded-none bg-secondary text-secondary-foreground px-10 py-6 text-base font-medium tracking-wide transition-all duration-300 hover:-translate-y-[2px] hover:shadow-xl hover:bg-accent relative overflow-hidden group">
              <Link to="/TrendingPage">
                <span className="relative z-10">Explore Names</span>
                {}
                <span className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}